<template>
  <div id="tag-designer-wrap" class="designer" :class="{'fullscreen': isFullScreen}">
    <div v-show="isFullScreen" class="d-flex scale-control">
      <!-- 缩放比例： -->
      <label class="mr10">缩放比例</label>
      <el-slider
        class="input90"
        v-model="scale"
        :min="1"
        :max="5"
        :step="0.5">
      </el-slider>
    </div>
    <div
      v-if="!!activatedItem && mode === 'design'"
      @mouseover="toggleEditLock('in')"
      @mouseout="toggleEditLock('out')"
      class="style-editor"
      :class="{'full': isFullScreen}"
    >
      <div class="d-flex">
        <div v-show="!activatedItem.img" class="d-flex mr10">
          <!-- 字号 -->
          <label class="mr5">字号:</label>
          <el-input-number
            class="input100"
            v-model="activatedItem.fontSize"
            :min="1"
            controls-position="right"
          ></el-input-number>
        </div>
        <div v-show="!activatedItem.img" class="d-flex mr10">
          <!-- 行高 -->
          <label class="mr5">行高:</label>
          <el-input-number
            class="input100"
            v-model="activatedItem.lineHeight"
            :min="1"
            controls-position="right"
          ></el-input-number>
        </div>
        <div v-show="!activatedItem.img" class="d-flex mr10">
          <!-- 粗体 -->
          <label class="mr5">粗体:</label>
          <el-select
            class="input100"
            v-model="activatedItem.bold"
          >
            <el-option :value="1" :label="`是`"></el-option>
            <el-option :value="0" :label="`否`"></el-option>
          </el-select>
        </div>
        <div
          v-show="!activatedItem.img && activatedItem.type !== 'list'"
          class="d-flex mr10">
          <!-- 对齐 -->
          <label class="mr5">对齐:</label>
          <el-select
            class="input100"
            v-model="activatedItem.textAlign"
          >
            <!-- 左边 -->
            <el-option :value="'left'" :label="`左边`"></el-option>
            <!-- 居中 -->
            <el-option :value="'center'" :label="`居中`"></el-option>
            <!-- 右边 -->
            <el-option :value="'right'" :label="`右边`"></el-option>
          </el-select>
        </div>
        <div v-show="!activatedItem.img" class="d-flex mr10">
          <!-- 反色 -->
          <label class="mr5">反色:</label>
          <el-checkbox v-model="activatedItem.backColor"></el-checkbox>
        </div>
        <!-- 移除 -->
        <el-button
          type="danger"
          class="ml20"
          size="small"
          @click="removeTag"
        >移除</el-button>
      </div>
    </div>

    <!-- 退出全屏 -->
    <el-button
      v-show="isFullScreen"
      class="exit-fullscreen-button"
      size="big"
      @click="toggleFullScreen">退出全屏</el-button>
    <!-- 全屏 -->
    <el-button
      v-if="mode === 'design'"
      v-show="!isFullScreen"
      :type="isFullScreen ? '' : 'warning'"
      class="exit-fullscreen-button"
      size="big"
      @click="toggleFullScreen">全屏</el-button>

    <div class="tag-container" id="tag-container" :class="{'full': isFullScreen, 'tile': mode === 'edit','d-flex center': mode !== 'edit'}" :style="`height: ${mode === 'edit' ? `${containerHeight}px` : ''}`">
      <div id="tag-area" class="tag-area" :style="{'width': `${size.width}px`, 'height': `${size.height}px`, 'transform': `scale(${scale})`, 'transform-origin': mode === 'edit' ? `${originW}px ${originH}px` : ''}">
        <vdr
          v-for="(i, d) in inList"
          :key="d"
          :ref="`${i.id}`"
          :class-name-draggable="`draggable ${activatedItem && i.id === activatedItem.id ? 'focusing' : ''}`"
          :class-name="`vdr ${activeKey === i.key && !activatedItem ? 'focusing' : ''} ${i.type === 'label' ? 'label-draggable' : ''}`"
          :draggable="mode === 'design'"
          :resizable="mode === 'design'"
          :snap="false"
          :w="i.width" 
          :h="i.height" 
          :x="i.x" 
          :y="i.y" 
          :parent="true" 
          :data-k="i.key"
          :scale-ratio="scale" 
          :style="{'overflow': i.type === 'list' ? 'hidden' : 'unset', 'background-color': `${i.backColor ? '#000' : 'transparent'}`, 'color': `${i.backColor ? '#fff' : '#000'}`}"
          @resizestop="resized" 
          @activated="activated(i)" 
          @dragstop="dragstop" 
          @deactivated="deactivated">
          <img
            v-if="i.img"
            style="width: 100%; height:100%;"
            :src="i.img"
          >
          <div v-else-if="i.type === 'list'" class="d-in" :style="{
            'font-size': `${i.fontSize}px`,
            'font-weight': `${i.bold ? 'bold' : 'normal'}`,
            'line-height': `${i.lineHeight}px`}">
            <div v-for="(t, d) in i.list" :key="d" style="display:flex;justify-content: space-between;">
              <span>{{t.name}}:</span><span>{{t.number || 0}}</span>
            </div>
          </div>
          <div v-else class="d-in" :style="{
            'font-size': `${i.fontSize}px`,
            'font-weight': `${i.bold ? 'bold' : 'normal'}`,
            'line-height': `${i.lineHeight}px`,
            'text-align': `${i.textAlign || 'left'}`
          }">{{i.text}}</div>
        </vdr>
        <div v-if="mode === 'edit'" class="mask" @click.prevent.stop="forbidClick"></div>
      </div>
    </div>
    <el-dialog
      :visible.sync="isShowDia"
      :title="`详情`"
      width="80%">
      <div style="height:400px"  class="dailog-vdr-box">
      <div class="tag-area" :style="{'width': `${size.width}px`, 'height': `${size.height}px`, 'transform': `scale(${2.2})`, 'transform-origin': '50% 0'}">
      <vdr
          v-for="(i, d) in inList"
          :key="d"
          :ref="`${i.id}`"
          :class-name-draggable="`draggable ${activatedItem && i.id === activatedItem.id ? 'focusing' : ''}`"
          :class-name="`vdr ${activeKey === i.key && !activatedItem ? 'focusing' : ''} ${i.type === 'label' ? 'label-draggable' : ''}`"
          :draggable="false"
          :resizable="false"
          :snap="false"
          :w="i.width" 
          :h="i.height" 
          :x="i.x" 
          :y="i.y" 
          :parent="true" 
          :data-k="i.key"
          :scale-ratio="scale" 
          :style="{'overflow': i.type === 'list' ? 'hidden' : 'unset', 'background-color': `${i.backColor ? '#000' : 'transparent'}`, 'color': `${i.backColor ? '#fff' : '#000'}`}"
          @resizestop="resized" 
          @activated="activated(i)" 
          @dragstop="dragstop" 
          @deactivated="deactivated">
          <img v-if="i.img" style="width: 100%; height:100%;" :src="i.img">
          <div v-else-if="i.type === 'list'" class="d-in" :style="{
            'font-size': `${i.fontSize}px`,
            'font-weight': `${i.bold ? 'bold' : 'normal'}`,
            'line-height': `${i.lineHeight}px`}">
            <div v-for="(t, d) in i.list" :key="d" style="display:flex;justify-content: space-between;">
              <span>{{t.name}}:</span><span>{{t.number || 0}}</span>
            </div>
          </div>
          <div v-else class="d-in" :style="{
            'font-size': `${i.fontSize}px`,
            'font-weight': `${i.bold ? 'bold' : 'normal'}`,
            'line-height': `${i.lineHeight}px`,
            'text-align': `${i.textAlign || 'left'}`
          }">{{i.text}}</div>
        </vdr>
        </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="big" @click="closeDia">关闭</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import vdr from 'vue-draggable-resizable-gorkys'
import 'vue-draggable-resizable-gorkys/dist/VueDraggableResizable.css'
export default {
  name: 'TagDesigner',
  components: {
    vdr
  },
  props: {
    mode: {
      type: String,
      default: 'design' // design, edit
    },
    inList: {
      type: Array,
      default: () => []
    },
    activeKey: {
      type: String,
      default: ''
    },
    size: {
      type: Object,
      default: () => {
        return {
          width: 500,
          height: 300
        }
      }
    }
  },
  watch: {
    size: {
      deep: true,
      handler() {
        this.handleResizeParent()
      }
    }
  },
  data() {
    return {
      isShowDia:false,
      dialogData:[],
      activatedItem: null,
      editLock: false,
      isFullScreen: false,
      grid: {
        width: 10,
        height: 10
      },
      scale: 1,
      originW: 0,
      originH: 0,
      containerHeight: 0
    }
  },
  methods: {
    setItemParams(params) {
      if (this.activatedItem) {
        this.inList.forEach(i => {
          if (this.activatedItem.id === i.id) {
            Object.assign(i, params)
          }
        })
      }
    },
    resized (x, y, width, height) {
      const params = {
        x,
        y,
        width,
        height
      }

      this.setItemParams(params)
    },
    dragstop(x, y) {
      const params = {
        x,
        y
      }

      this.setItemParams(params)
    },
    activated(activated) {
      this.$set(activated, 'backColor', activated.backColor || false)

      this.$nextTick(() => {
        this.activatedItem = activated
      })
    },
    deactivated() {
      if (this.editLock) return

      this.activatedItem = null
    },
    removeTag() {
      if (!this.activatedItem) return
      const { activeElement } = document
      const { nodeName } = activeElement || {}
      if (nodeName.toLowerCase() === 'input') return

      this.$emit('removeItem', this.activatedItem.id)
      this.activatedItem = null
    },
    toggleEditLock(state) {
      // 编辑锁，用于防止编辑时失去正在编辑的组件
      switch (state) {
        case 'in':
          this.editLock = true
          break;
      
        case 'out':
          this.editLock = false
          break;
      }
    },
    toggleFullScreen() {
      this.isFullScreen = !this.isFullScreen
      if (!this.isFullScreen) {
        this.scale = 1
      }
    },
    initGridStyle() {
      // 初始化标尺样式
      const { width, height } = this.grid

      this.setGridStyle({
        w: width,
        h: height
      })
    },
    setGridStyle(style) {
      const { w, h} = style
      if (w) {
        this.$el.style.setProperty('--gridWidth', `${w}px`)
      }

      if (h) {
        this.$el.style.setProperty('--gridHeight', `${h}px`)
      }
    },
    handleResizeParent() {
      // 改变容器尺寸后触发组件功能，防止拖动功能出错
      this.calcScale()
      this.$nextTick(() => {
        this.inList.forEach(i => {
          const instance = this.$refs[`${i.id}`] ? this.$refs[`${i.id}`][0] : undefined
          if (instance) {
            instance.checkParentSize()
          }
        })
      })
    },
    listenOnKeybord() {
      // 监听键盘事件
      if (this.mode !== 'design') return
      window.document.addEventListener('keydown', this.listenDirectionKeys)
    },
    stopListenOnKeybord() {
      // 取消监听键盘事件
      window.document.removeEventListener('keydown', this.listenDirectionKeys)
    },
    listenDirectionKeys(e) {
      // 监听按键
      const { keyCode } = e
      switch(keyCode) {
        case 37:
          this.moveKeyword('left')
          break;
        case 38:
          this.moveKeyword('top')
          break;
        case 39:
          this.moveKeyword('right')
          break;
        case 40:
          this.moveKeyword('bottom')
          break;
        case 8:
          this.removeTag()
          break;
        case 46:
          this.removeTag()
          break;
      }
    },
    moveKeyword(direction) {
      if (!this.activatedItem) return
      let { x, y } = this.activatedItem
      switch (direction) {
        case 'top':
          y -= 1
          this.activatedItem.y = y
          break;

        case 'bottom':
          y += 1
          this.activatedItem.y = y
          break;

        case 'left':
          x -= 1
          this.activatedItem.x = x
          break;

        case 'right':
          x += 1
          this.activatedItem.x = x
          break;
      }
    },
    forbidClick() {
      this.isShowDia = true
      return false
    },
    closeDia(){
      this.isShowDia = false
    },
    calcScale() {
      // 计算变形比例
      if (this.mode === 'edit') {
        const tagContainer = document.querySelector('#tag-designer-wrap')
        const tagContainerRect = tagContainer.getBoundingClientRect()
        const {
          width: containerWidth
        } = tagContainerRect
        const {
          width,
          height
        } = this.size
        this.originH = height/2
        const scale = containerWidth/(width + 4)
        this.scale = scale
        // this.containerHeight = height * scale + 20
        this.$nextTick(() => {
          const tagArea = document.querySelector('#tag-area')
          const tagAreaRect = tagArea.getBoundingClientRect()
          const {
            height: tagAreaDomHeight
          } = tagAreaRect

          this.containerHeight = tagAreaDomHeight + 40
        })
      }
    },
    sizeMonitor() {
      // 监听页面尺寸变化重新计算标签尺寸
      const pageHeight = this.$parent.$el.getBoundingClientRect().height
      const pageAvailableHeight = document.body.clientHeight - 50
      const paddingH = 15 * 2
      const hasScrollBar = pageHeight > (pageAvailableHeight - paddingH )
      if (hasScrollBar) {
        this.calcScale()
      }
    },
    calcuRatio(){
      const element = document.getElementById('tag-container');
      const rect = element.getBoundingClientRect();
      let boxWHR = rect.width / rect.height // 页面的vdr的盒子宽高比例
      let vdrWHR = this.size.width / this.size.height // vdr的盒子宽高比例
      if(boxWHR<vdrWHR){
        this.scale = rect.width / this.size.width
      }else{
        this.scale = rect.height / this.size.height
      }
      this.scale = this.scale - 0.03

    }
  },
  mounted() {
    this.initGridStyle()
    this.listenOnKeybord()

    // if(this.mode == 'edit'){
    //   this.scale = 2
    // }
    // this.calcScale()
    if(this.mode == 'edit'){
      // setTimeout(()=>{
        this.calcuRatio()
      // },1000)
      
    }
  },
  updated() {
    this.sizeMonitor()
  },
  beforeDestroy() {
    this.stopListenOnKeybord()
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/css/common.scss';
  .vdr {
    border-color: $main_color_deep;
  }
  .draggable {
    border-color: $main_color_deep;
  }
  .label-draggable {
    border-color: $main_color_warning;
  }
  .tag-container {
    min-height: 500px;
    &.full {
      height: 100vh !important;
    }
    &.tile {
      justify-content: flex-start;
      // background: red;
      min-height: 400px;
      // transform: scale(1.5);
    }
  }
  .fullscreen {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba($color: #000000, $alpha: 0.7);
    z-index: 999;
  }
  .scale-control {
    position: absolute;
    right: 30px;
    top: 70px;
    padding: 0 20px;
    background-color: #fff;
    border-radius: 6px;
    z-index: 99;
    border: 4px solid lightgray;
  }
  .style-editor {
    &.full {
      position: absolute;
      left: 30px;
      top: 70px;
      label {
        color: #fff;
      }
    }
  }
  .tag-area {
    box-sizing: content-box;
    border: 2px solid gray;
    background: linear-gradient(rgba(0, 0, 0, .1) 1px, transparent 0), 
                linear-gradient(90deg, rgba(0, 0, 0, .1) 1px, transparent 0);
    background-size: var(--gridWidth) var(--gridHeight);
    background-color: #fff;
    z-index: 98;
    position: relative;
    .mask {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }
  .focusing {
    background-color: rgba($main_color_deep, 0.3) !important;
  }
  .exit-fullscreen-button {
    position: absolute;
    right: 30px;
    bottom: 20px;
    z-index: 99;
  }
    .dailog-vdr-box{
    width: 100%;
    display: flex;
    justify-content: center;

  }
</style>